import { IPrintedDocument } from 'us.collection.case/reducers/Dashboard/Interfaces'

export const PrintedDocument: IPrintedDocument = {
    data: [],
    isLoading: false,
    error: ""
}